"use strict";
/**
 * @module Serialisers
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../io/codec");
/**
 * A Serialiser for 32 bit integer values.
 *
 * This corresponds to :integer in the protocol definition.
 */
var IntegerSerialiserClass = /** @class */ (function () {
    function IntegerSerialiserClass() {
    }
    /**
     * @inheritdoc
     */
    IntegerSerialiserClass.prototype.read = function (bis) {
        return Codec.readInt32(bis);
    };
    /**
     * @inheritdoc
     */
    IntegerSerialiserClass.prototype.write = function (bos, val) {
        Codec.writeInt32(bos, val);
    };
    return IntegerSerialiserClass;
}());
exports.IntegerSerialiserClass = IntegerSerialiserClass;
/**
 * The {@link IntegerSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.IntegerSerialiser = new IntegerSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/serialisers/integer-serialiser.js
// module id = 1257
// module chunks = 1